import { createAsyncThunk } from "@reduxjs/toolkit";
import server from "../middleware/interceptor";
//the requestbody is an object containing user_id(string) ,prompt(string|null),Subject_id(integer|null)
//conversation_id(string|null),image(string|null) 
interface GetSelectTopicArgs {
  conversationId: string;
  topicTitle: string;
  description:string;
  subject:string;
}

export const startOrContinueChat = createAsyncThunk(
  "chatai/chat/start",
  async (requestBody: any, { rejectWithValue }) => {
    try {
      const response = await server.post(`/chatai/chat/start`, requestBody, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const { data } = response;
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message || "Something went wrong");
    }
  }
);

export const getUserConversations = createAsyncThunk(
  "chatai/chat/getUserConversations",
  async (userId: any, { rejectWithValue }) => {
    try {
      const response = await server.get(`/chatai/conversations/student/${userId}`, {
        headers: {
          "Content-Type": "application/json",
        }
      });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data || "Something went wrong")
    }
  }
);

export const getConversation = createAsyncThunk(
  "chatai/chat/getConversations",
  async (conversationId: any, { rejectWithValue }) => {
    try {
      const response = await server.get(`/chatai/conversations/${conversationId}`, {
        headers: {
          "Content-Type": "application/json",
        }
      });
      
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data || "Something went wrong")
    }
  }
)

export const renameConversation = createAsyncThunk(
  "chatai/chat/renameConversations",
  async (requestBody: any, { rejectWithValue }) => {
    try {
      const response = await server.put(`/chatai/conversations/${requestBody.conversation_Id}/rename`, requestBody.renameTitle, {
        headers: {
          "Content-Type": "application/json",
        }
      });
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response.data || "Something went wrong")
    }
  }

)

export const deleteConversation = createAsyncThunk(
  "chatai/chat/deleteConversations",
  async (conversationId: any, { rejectWithValue }) => {
    try {
      const response = await server.delete(`/chatai/conversations/${conversationId}/delete`, {
        headers: {
          "Content-Type": "application/json",
        }
      });
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response.data || "Something went wrong")
    }
  }

)

// export const getTopic = createAsyncThunk(
//   "chatai/chat/getTopic",
//   async (conversationId: any, { rejectWithValue }) => {
//     try {
//       const response = await server.post(`chatai/conversations/${conversationId}/topics?require_admin=false`, {
//         headers: {
//           "Content-Type": "application/json",
//         }
//       });
//       return response?.data;
//     } catch (error: any) {
//       return rejectWithValue(error.response.data || "Something went wrong")
//     }
//   }

// )

export const getSelectTopic = createAsyncThunk(
  "chatai/chat/getSelectTopic",
  async ({ conversationId, topicTitle,description,subject }: GetSelectTopicArgs, { rejectWithValue }) => {
    try {
      const response = await server.post(
        `/chatai/conversations/${conversationId}/select-topic?topic=${topicTitle}&topic_description=${description}&subject=${subject}&require_admin=false`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const getSelectedTopic = createAsyncThunk(
  "chatai/chat/getSelectedTopic",
  async ({ conversationId }: {conversationId: string}, { rejectWithValue }) => {
    try {
      const response = await server.get(
        `/chatai/conversations/${conversationId}/selected-topic?require_admin=false`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
